import { render, staticRenderFns } from "./planetList.vue?vue&type=template&id=b91537e6&scoped=true"
import script from "./planetList.vue?vue&type=script&lang=js"
export * from "./planetList.vue?vue&type=script&lang=js"
import style0 from "./planetList.vue?vue&type=style&index=0&id=b91537e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91537e6",
  null
  
)

export default component.exports